import { Stack } from 'expo-router';
import { CustomTextStyles } from '@/components/CustomText';
import { AppText } from '@/components/AppText';
import DrawerButton from '@/components/DrawerButton';
import { HeaderLeft } from '@/components/HeaderLeft';
import { WidthResponsiveText } from '@/components/WidthResponsiveText';

export default function StackedLoggedIn() {
  return (
    <Stack
      screenOptions={{
        // Remove horizontal bottom line for header
        headerShadowVisible: false,

        headerStyle: {
          backgroundColor: 'transparent',
        },

        headerBackTitle: '',

        headerBackButtonDisplayMode: 'minimal',

        headerTitle: ({ children }) => (
          <WidthResponsiveText leftPadding={50} rightPadding={50} style={CustomTextStyles.headerTitle}>
            {children}
          </WidthResponsiveText>
        ),

        headerLeft: () => <HeaderLeft />,

        headerRight: () => <DrawerButton />,
      }}
    >
      <Stack.Screen name="email" options={{ title: 'Your Email' }} />
      <Stack.Screen name="setlogin" options={{ title: 'Email & Password' }} />
      <Stack.Screen name="password" options={{ title: 'Your Password' }} />
      <Stack.Screen name="age" options={{ title: 'Your Age' }} />
      <Stack.Screen name="visuals" options={{ title: 'Visuals' }} />
      <Stack.Screen name="location" options={{ title: 'Your Location' }} />
      <Stack.Screen name="aboutyou" options={{ title: 'About you' }} />
      <Stack.Screen name="name" options={{ title: 'Your Name' }} />
      <Stack.Screen name="desires" options={{ title: 'Desires' }} />
      <Stack.Screen name="desired_ages" options={{ title: 'Desired Ages', gestureEnabled: false }} />
      <Stack.Screen name="preferences" options={{ title: 'Preferences' }} />
      <Stack.Screen name="profilesettings" options={{ title: 'Profile Settings' }} />
      <Stack.Screen name="userinfo" options={{ title: 'Cookies' }} />
      <Stack.Screen name="paycomplete" options={{ title: 'Payment Successful' }} />
      <Stack.Screen name="pickprofile" options={{ title: 'Profile' }} />
      <Stack.Screen name="socialmedia" options={{ title: 'Social Media' }} />
      <Stack.Screen name="height" options={{ title: 'Your height', gestureEnabled: false }} />
      <Stack.Screen name="filter" options={{ title: 'Filter', gestureEnabled: false }} />
      <Stack.Screen name="optionalsettings" options={{ title: 'Optional Settings' }} />
      <Stack.Screen name="ethnicity" options={{ title: 'Ethnicity' }} />
      <Stack.Screen name="religion" options={{ title: 'Religion' }} />
      <Stack.Screen name="children" options={{ title: 'Children' }} />
      <Stack.Screen name="intentions" options={{ title: 'Intentions' }} />
      <Stack.Screen name="alcohol" options={{ title: 'Alcohol' }} />
      <Stack.Screen name="cigarettes" options={{ title: 'Cigarettes' }} />
      <Stack.Screen name="weed" options={{ title: 'Weed' }} />
      <Stack.Screen name="drugs" options={{ title: 'Drugs' }} />
      <Stack.Screen name="politics" options={{ title: 'Politics' }} />
    </Stack>
  );
}
